import React, { useState, useEffect, useMemo } from "react"
import { useDispatch, useSelector } from "react-redux"
import { FIGURE, FIGURE_COMMAND } from "../logic/chartConfig"
import {
  changeFigure,
  changeFigureType,
  changeFigureOptions,
  figureAllClear,
  changeFigureCommand,
  chartPropatyObj,
} from "redux/ducks/Chart"
import { ChartFigureSettingModal } from "./ChartFigure"
import _ from "lodash"
import ClassNames from "classnames"

interface props {
  canvasId: string
}

const ChartFigureButtons = React.memo((props: props) => {
  const { canvasId } = props
  const typesData = useMemo(() => {
    let data: Array<Array<chartPropatyObj>> = []
    _.forEach(FIGURE, items => data.push(_.get(items, "type", [])))
    return _.flattenDeep(data)
  }, [])
  const dispatch = useDispatch()
  const defaultFigureOptionsSelector = (state: any) =>
    state.chart.defaultFigureOptions
  const figureSelector = (state: any) => state.chart[canvasId].figure
  const figureTypeSelector = (state: any) => state.chart[canvasId].figureType
  const figureCommandSelector = (state: any) =>
    state.chart[props.canvasId].figureCommand

  const defaultFigureOptions = useSelector(defaultFigureOptionsSelector)
  const figure = useSelector(figureSelector)
  const figureType = useSelector(figureTypeSelector)
  const figureCommand = useSelector(figureCommandSelector)

  const [selectedFigureCommand, setSelectedFigureCommand] = useState(null)
  const [selectedFigure, setSelectedFigure] = useState(null)
  const [settingModal, setSettingModal] = useState(false)

  const _setSelectedFigure = (id: number) => {
    setSelectedFigureCommand(null)
    dispatch(changeFigureCommand(props.canvasId, null))

    if (selectedFigure === id) {
      dispatch(figureAllClear(props.canvasId))
      setSelectedFigure(null)
      return
    }
    setSelectedFigure(id)
  }

  const _setSettingModal = () => {
    dispatch(figureAllClear(canvasId))
    setSelectedFigureCommand(null)
    setSelectedFigure(null)
    setSettingModal(!settingModal)
  }

  const onHide = () => {
    dispatch(figureAllClear(canvasId))
    setSelectedFigureCommand(null)
    setSelectedFigure(null)
    setSettingModal(false)
  }

  const changeSelectedFigureCommand = (id: number) => {
    setSelectedFigure(null)
    dispatch(figureAllClear(props.canvasId))
    if (selectedFigureCommand === id) {
      dispatch(changeFigureCommand(props.canvasId, null))
      setSelectedFigureCommand(null)
      return
    }
    setSelectedFigureCommand(id !== FIGURE_COMMAND[3].id ? id : null)
    dispatch(changeFigureCommand(props.canvasId, id))
  }

  const setFigure = (id: number) => {
    // 図形コマンドを空にする
    setSelectedFigureCommand(null)
    dispatch(changeFigureCommand(canvasId, null))
    dispatch(figureAllClear(canvasId))
    // if (figure.id === id || id === null) return
    // dispatch(changeFigure(canvasId, id))
  }

  const setFigureType = (figureid: number, id: number) => {
    dispatch(changeFigureOptions(canvasId, figureid, id, []))
    if (figureType.id === id) {
      return dispatch(changeFigureType(canvasId, figureid, null))
    }
    dispatch(changeFigureType(canvasId, figureid, id))
  }

  useEffect(() => {
    if (!selectedFigure && selectedFigure !== 0) return
    const key = typesData[selectedFigure].key as string
    const selectedFigureData = defaultFigureOptions[key]
    // setFigure(selectedFigureData.figure)
    setFigureType(selectedFigureData.figure, typesData[selectedFigure].id)
    setTimeout(() => {
      dispatch(
        changeFigureOptions(
          canvasId,
          selectedFigureData.figure,
          typesData[selectedFigure].id,
          _.get(selectedFigureData, "option")
        )
      )
    })
  }, [selectedFigure])

  useEffect(() => {
    return () => dispatch(figureAllClear(canvasId))
  }, [])

  return (
    <div className="tech-chart-buttons">
      {_.map(typesData, (items, index) => {
        return (
          <div
            key={index}
            className="btn-multi-control"
            title={items.displayTitle}
          >
            <label
              className={ClassNames("btn btn-outline shaped", {
                active:
                  (selectedFigure || selectedFigure === 0) &&
                  typesData[selectedFigure].key === items.key,
              })}
            >
              <input
                type="checkbox"
                className="input-multi-control"
                onChange={() => _setSelectedFigure(index)}
              />
              <i className={ClassNames("material-icons", items.iconTransform)}>
                {items.icon}
              </i>
            </label>
          </div>
        )
      })}
      {_.map(FIGURE_COMMAND, items => {
        return (
          <div
            key={items.id}
            className="btn-multi-control"
            title={items.displayTitle}
          >
            <label
              className={ClassNames("btn btn-outline shaped", {
                active: selectedFigureCommand === items.id,
              })}
            >
              <input
                type="checkbox"
                className="input-multi-control"
                onChange={() => changeSelectedFigureCommand(items.id)}
              />
              <i className="material-icons">{items.icon}</i>
            </label>
          </div>
        )
      })}
      <div className="btn-multi-control" title="ライン設定">
        <label className="btn btn-outline shaped">
          <input
            type="checkbox"
            className={ClassNames("input-multi-control", {
              active: settingModal,
            })}
            onChange={() => _setSettingModal()}
          />
          <i className="material-icons">settings</i>
        </label>
      </div>
      <ChartFigureSettingModal
        canvasId={canvasId}
        onHide={onHide}
        show={settingModal}
      />
    </div>
  )
})

export default ChartFigureButtons
